module.exports = __webpack_public_path__ + "static/media/electronic-on.07c842e9.svg";